import React from 'react';
import Video from 'components/UI/Video';
import { observer, storage } from 'store';

import * as styles from './HeroVideo.module.scss';

function HeroVideo({ video, isDesktop }) {
  const videoLoaded = storage.getItem('showVideo');

  return (
    isDesktop &&
    videoLoaded && (
      <Video className={styles.video} source={video} preload="auto" autoPlay loop muted />
    )
  );
}

export default observer(HeroVideo);
